import React, { useEffect, useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { useDispatch, useSelector } from "react-redux";
import useFacility from "../../../utils/hooks/useFacility";
import { State } from "../../store";
import { SubmitHandler, useForm } from "react-hook-form";
import { USER_EDIT_DATA_URL } from "../../api/apiRoutes";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import FormInput from "../../../utils/FormInput";
import { emailValidator, phoneValidator } from "../../../utils/formsValidation";
import FormInputReadOnly from "../../../utils/FormInputReadOnly";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import EAModal from "../shared/Modal/EAModal";

type Inputs = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

const AccountData: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const webUser = useSelector((state: State) => state.auth.userData);
  const canCustomerEditData = useSelector((state: State) => state.config.configuration.canCustomerEditData);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      firstName: webUser.firstName,
      lastName: webUser.lastName,
      email: webUser.email,
      phone: webUser.phone,
    },
  });

  const handleEditUserData: SubmitHandler<Inputs> = async ({ firstName, lastName, email, phone }: Inputs) => {
    const { isError } = await post(USER_EDIT_DATA_URL(facilityIds), { ...webUser, firstName, lastName, email, phone });
    if (!isError) {
      dispatch(setSuccessMessage(t("operacja_przebiegla_pomyslnie")));
      setOpen(false);
    }
  };

  const [, setAllow] = useState(true);
  useEffect(() => {
    if (canCustomerEditData) {
      setAllow(true);
    } else {
      setAllow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <React.Fragment>
      <EAButton title={t("dane_konta")} onClick={() => setOpen(true)} variant="text" fullWidth />

      {open && (
        <EAModal
          isOpen={open}
          onClose={() => setOpen(false)}
          title={"Dokumenty"}
          hideAcceptButton
          acceptButtonLabel={t("Zamknij")}
          // hideButtons
          // acceptButtonLabel={t("Zamknij")}
          // isOpen={open}
          // onClose={() => setOpen(false)}
          //   title={t("dane_konta")}
          //   onAccept={handleSubmit(handleEditUserData)}
        >
          <React.Fragment>
            {canCustomerEditData ? (
              <form onSubmit={handleSubmit(handleEditUserData)}>
                <FormInput
                  type={"text"}
                  name={"firstName"}
                  text={t("imie")}
                  register={{ ...register("firstName", { required: true }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.firstName}
                />
                <FormInput
                  type={"text"}
                  name={"lastName"}
                  text={t("nazwisko")}
                  register={{ ...register("lastName", { required: true }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.lastName}
                />
                <FormInput
                  type={"text"}
                  name={"email"}
                  text={"E-mail"}
                  register={{ ...register("email", { ...emailValidator(true) }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.email}
                />
                <FormInput
                  type={"number"}
                  name={"phone"}
                  text={t("telefon_kontaktowy")}
                  register={{ ...register("phone", { ...phoneValidator(true) }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.phone}
                />
              </form>
            ) : (
              <form onSubmit={handleSubmit(handleEditUserData)}>
                <FormInputReadOnly
                  type={"text"}
                  name={"firstName"}
                  text={t("imie")}
                  register={{ ...register("firstName", { required: true }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.firstName}
                />
                <FormInputReadOnly
                  type={"text"}
                  name={"lastName"}
                  text={t("nazwisko")}
                  register={{ ...register("lastName", { required: true }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.lastName}
                />
                <FormInputReadOnly
                  type={"text"}
                  name={"email"}
                  text={"E-mail"}
                  register={{ ...register("email", { ...emailValidator(true) }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.email}
                />
                <FormInputReadOnly
                  type={"number"}
                  name={"phone"}
                  text={t("telefon_kontaktowy")}
                  register={{ ...register("phone", { ...phoneValidator(true) }) }}
                  errors={errors}
                  isLabel
                  defaultValue={webUser.phone}
                />
              </form>
            )}
          </React.Fragment>
        </EAModal>
      )}
    </React.Fragment>
  );
};

export default AccountData;
